import { useParams } from "react-router-dom";
import { Cards, Crumbs, GuideCards } from "../components/Bits";
import { Head } from "../components/Head";
import { tagged, useData } from "../lib/data";
import { AUTHOR } from "../lib/util";
import NotFound from "./NotFound";

export function GuidesIndex() {
  const { guides } = useData();
  return (
    <>
      <Head title="Guides til køkkenet" path="guides/" desc="Guides om billig mad, airfryer, mealprep, frysning, holdbarhed, kogetider og madplanlægning." />
      <Crumbs trail={[[null, "Guides"]]} />
      <div className="wrap"><div className="ptop"><h1>Guides</h1>
        <p className="lead">Praktiske guides til køkkenet: spar penge, brug airfryeren rigtigt, lav mealprep og undgå madspild.</p></div>
        <GuideCards gs={guides} /></div>
    </>
  );
}

export function Guide() {
  const { slug } = useParams();
  const { GBY, guides, recipes } = useData();
  const g = GBY[slug];
  if (!g) return <NotFound />;
  const rel = tagged(recipes, g.rel).sort((a, b) => a.price - b.price).slice(0, 4);
  const others = guides.filter(x => x.slug !== g.slug).slice(0, 3);
  const body = g.body.replace(/\[\[(.*?)\]\]/g, (_, p) => "/" + p);
  const ld = [{ "@context": "https://schema.org", "@type": "Article", headline: g.title, description: g.desc,
    datePublished: g.created_at.slice(0, 10), inLanguage: "da", author: { "@type": "Organization", name: AUTHOR } }];
  return (
    <>
      <Head title={g.title} desc={g.desc} path={`guides/${g.slug}/`} ogType="article" ld={ld} />
      <Crumbs trail={[["guides/", "Guides"], [null, g.title]]} />
      <article className="wrap">
        <div className="ptop"><h1 data-testid="guide-title">{g.title}</h1><p className="lead">{g.desc}</p></div>
        <div className="prose" data-testid="guide-body" dangerouslySetInnerHTML={{ __html: body }} />
        <div className="blk"><div className="sh"><h2>Opskrifter, der passer</h2></div><Cards rs={rel} /></div>
        <div className="blk"><div className="sh"><h2>Flere guides</h2></div><GuideCards gs={others} /></div>
      </article>
    </>
  );
}
